export default function cleanUpNumbers(value) {
  return value.replace(/\D/g, '')
}
